export default function AmazonSalesBanner() {
  return (
    <div className='bg-mi-on-surface-accent-secondary py-2 text-center text-white'>
      <p className='text-base font-semibold leading-[25px] tracking-[-0.41px]'>
        期間限定！Amazonで購入すると10%OFF
      </p>
      <p className='text-sm font-light leading-[22px] tracking-[-0.24px]'>4月17日 23:59まで</p>
    </div>
  )
}
